<template>
  <div id="main-wrapper">
    <div class="row">
      <div class="col-md-3 center">
        <div class="login-box">
          <div class="logo-box">
            <img src="/static/medialab.png" />
          </div>
          <form class="m-t-md" @submit.prevent="CheckData">
            <div class="form-group">
              <input
                v-model="login"
                type="text"
                class="form-control"
                placeholder="Login"
                required
                autofocus
              />
            </div>
            <div class="form-group">
              <input
                v-model="password"
                type="password"
                class="form-control"
                placeholder="Password"
                required
              />
            </div>
            <div class="login-language-select form-group">
              <component is="LanguageSwitcher"></component>
            </div>
            <button type="submit" class="btn btn-success btn-block">
              {{ $t("message.Login") }}
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- Row -->
  </div>
</template>

<script>
import Vue from "vue";
import LanguageSwitcher from "../Nav/LanguageSwitcher";
export default {
  name: "Login",
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      login: "",
      password: ""
    };
  },
  created() {
    if (this.$storage.get("access_token")) {
      this.$router.push("/");
    }
  },

  methods: {
    CheckData() {
      let response = this.$noname.post(
        "login",
        { username: this.login, password: this.password },
        {}
      );

      response.then(data => {
        this.$storage.set("access_token", data.data.access_token, {
          ttl: 60 * 60 * 24 * 1000
        });
        this.$storage.set("refresh_token", data.data.refresh_token, {
          ttl: 60 * 60 * 24 * 1000
        });
        this.$router.push("/");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Login.vue